import React, { FC } from 'react';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import styled from '@emotion/styled';
import Drawer from '@mui/material/Drawer';
import useWindowDimensions from 'hooks/use-window-dimensions';
import { ZIndexes } from 'enums/z-indexes';
import {SCREEN_SIZE_SM } from 'constants/frontend-contsants';
import { useTranslation } from 'react-i18next';
import ErrorIcon from '@mui/icons-material/Error';
import { colors } from 'constants/colors';

const StyledErrorIconBox = styled(Box)({
    position:'absolute',
    backgroundColor: colors.default.info,
    borderRadius:'50%',
    top:0,
    transform:'translateY(-50%)',
    zIndex:91919191191919
});

const StyledErrorIcon = styled(ErrorIcon)({
    width:'70px',
    height:'70px',
    color:"red",
});

const StyledDrawer = styled(Drawer)({
  zIndex: ZIndexes.External_Modal_First,

  '& .MuiDrawer-paper': {
    maxWidth: '100%',
    width: '100%',
    minWidth: '390px',
    borderRadius: '30px 30px 0 0',
    border: 'none',
    boxShadow: 'none',
    textAlign: 'center',
    height: '55dvh',
    backgroundColor: colors.default.info,
    overflow:'unset'
  },
});

const StyledBox = styled(Box)({
    position:'relative',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  gap:'20px',
  alignItems: 'center',
  backgroundColor: colors.default.info,
  padding: '45px 10px',
  borderRadius: '40px',
});

interface UnablePaymentModalProps {
  open: boolean;
  onCancel: () => any;
}

const UnablePaymentModal: FC<UnablePaymentModalProps> = ({
  open,
  onCancel,
}) => {
  const { width } = useWindowDimensions();
  const { t } = useTranslation();

  const content = (
    <>
      <StyledErrorIconBox>
        <StyledErrorIcon />
      </StyledErrorIconBox>
      <Typography variant="error-payment">
        {t('headers.unable-payment')}
      </Typography>
      <Typography variant='body1'>{t('texts.contact-payment-provider')}</Typography>
      <Button
        variant="contained"
        onClick={onCancel}
        sx={{ marginTop: '40px', width: '100%' }}
      >
        {t('buttons.another-payment')}
      </Button>
    </>
  );

  if (width < SCREEN_SIZE_SM) {
    return (
      <StyledDrawer anchor="bottom" open={open} onClose={onCancel}>
        <StyledBox position={'relative'}>{content}</StyledBox>
      </StyledDrawer>
    );
  }

  return (
    <Modal
      open={open}
      onClose={onCancel}
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '400px',
        textAlign: 'center',
        margin: 'auto',
      }}
    >
      <StyledBox>{content}</StyledBox>
    </Modal>
  );
};

export default UnablePaymentModal;
